import React from "react";

import { House, NotListedLocation, PeopleAlt, Place } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

import { StatBox } from "@/components/atoms";
import { AudienceSummary } from "@/types";
import { abbreviateNumber } from "@/utils";

interface AudienceSizeProps {
  data: AudienceSummary;
}

const AudienceSize: React.FC<AudienceSizeProps> = ({ data }) => {
  return (
    <>
      <Grid size={12}>
        <Stack direction="row" spacing={2}>
          {data.num_postcodes !== undefined && (
            <StatBox
              name="Postcodes"
              value={data.num_postcodes}
              valueFormatter={abbreviateNumber}
              icon={<Place fontSize="small" color="secondary" />}
              estimate={data.estimate}
            />
          )}
          {data.num_sectors !== undefined && (
            <StatBox
              name="Sectors"
              value={data.num_sectors}
              valueFormatter={abbreviateNumber}
              icon={<Place fontSize="small" color="secondary" />}
              estimate={data.estimate}
            />
          )}
          {data.num_households !== undefined && (
            <StatBox
              name="Households"
              value={data.num_households}
              valueFormatter={abbreviateNumber}
              icon={<House fontSize="small" color="secondary" />}
              estimate={data.estimate}
            />
          )}
          {data.population_count !== undefined && (
            <StatBox
              name="Audience Size"
              value={data.population_count}
              valueFormatter={abbreviateNumber}
              icon={<PeopleAlt fontSize="small" color="secondary" />}
              estimate={data.estimate}
            />
          )}
          {data.invalid !== undefined && data.invalid !== '' && (
            <StatBox
              name="Invalid Sites"
              value={data.invalid.split(',').length}
              valueFormatter={abbreviateNumber}
              icon={<NotListedLocation fontSize="small" color="secondary" />}
              help={
              `
                A site can be invalid either because it is not in the correct
                postcode format or because the postcode doesn't exist in our data. 
                
                The following postcodes are invalid:
                
                ${data.invalid.split(',').map(x => `"${x}"`).join(', ')}
              `}
            />
          )}
        </Stack>
        {data.estimate && (
          <Typography variant="caption" color="textSecondary">
            * These values are estimates and will be updated when the traveltime catchments are created.
          </Typography>
        )}
      </Grid>
    </>
  );
};

export default AudienceSize;
